import {type Component} from 'vue';

export type BadgeColor = 'green' | 'orange' | 'blue' | 'red';

// one entry of the rail; the badges carry the reporter's ready/todo counts as CabLink did
export type NavItem = {
    label: string;
    to: string;
    icon: Component;
    exact?: boolean; // false: also active on child routes (a tab with sub-tabs)
    badge?: number;
    badgeColor?: BadgeColor;
    badgeExtra?: number;
    badgeExtraColor?: BadgeColor;
};

export const BADGE_CLASS: Record<BadgeColor, string> = {
    green : 'bg-zzc-groen text-zzc-antraciet',
    orange: 'bg-zzc-warning text-white',
    blue  : 'bg-zzc-blauw text-white ring-1 ring-white',
    red   : 'bg-zzc-danger text-white',
};
